import { render, staticRenderFns } from "./CriteriaPanelistsManager.vue?vue&type=template&id=2029faca&scoped=true"
import script from "./CriteriaPanelistsManager.vue?vue&type=script&lang=ts"
export * from "./CriteriaPanelistsManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029faca",
  null
  
)

export default component.exports